import { useParams } from 'react-router';

import { selectInitialDashboardName } from '@/features/dashboard/state/dashboardEdit.selectors';
import { useAppSelector } from '@/store/hooks';

export const useInitialDashboardName = (): string => {
  const { dashboardId } = useParams<{ dashboardId?: string }>();
  const fromRedux = useAppSelector(selectInitialDashboardName);
  return fromRedux || (dashboardId ? decodeURIComponent(dashboardId) : '');
};
